import React, { useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Welcome from './auth/Welcome';

const AuthPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Sur mobile, on démarre sur la page d'accueil (maquette F1 Accueil) ;
  // sur desktop, le panneau de marque est déjà visible, on va direct au login.
  const [view, setView] = useState(() => (window.innerWidth < 900 ? 'welcome' : 'login'));
  const [resetToken, setResetToken] = useState(null);

  useEffect(() => {
    // Vérifier si l'URL contient un token de réinitialisation
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      setResetToken(token);
      setView('reset');
    }
  }, []);

  // La page d'accueil n'a de sens que sur mobile : on bascule sur le login en desktop.
  useEffect(() => {
    if (!isMobile && view === 'welcome') {
      setView('login');
    }
  }, [isMobile, view]);

  if (view === 'reset' && resetToken) {
    return <ResetPassword token={resetToken} onSuccess={() => setView('login')} />;
  }

  if (view === 'welcome') {
    return (
      <Welcome
        onLogin={() => setView('login')}
        onRegister={() => setView('register')}
      />
    );
  }

  if (view === 'forgot') {
    return <ForgotPassword onBackToLogin={() => setView('login')} />;
  }

  const backToWelcome = isMobile ? () => setView('welcome') : undefined;

  return view === 'login' ? (
    <Login
      onSwitchToRegister={() => setView('register')}
      onForgotPassword={() => setView('forgot')}
      onBackToWelcome={backToWelcome}
    />
  ) : (
    <Register
      onSwitchToLogin={() => setView('login')}
      onBackToWelcome={backToWelcome}
    />
  );
};

export default AuthPage;
